<template>
    <div class="bg-white p-4 shadow-sm rounded-lg">
        <div>
            <close-requests></close-requests>
            <Alerts :_success="success" :_error="error"></Alerts>

            <h4 class="font-weight-bold mb-3">Create a New ERP</h4>
            <div class="mb-4">
                <p class="text-muted">Choose how you would like to create a new ERP:</p>

                <!-- Fixed: Changed from custom-switch to custom-radio -->
                <div class="custom-control custom-radio mb-3">
                    <input type="radio" class="custom-control-input" value="template"
                           id="budgeting-template" v-model="method" name="erp-method">
                    <label class="custom-control-label" for="budgeting-template">
                        Create New ERP
                    </label>
                    <small class="form-text text-muted">
                        Use this option to create a new ERP.
                    </small>
                </div>

                <hr>

                <!-- Fixed: Changed from custom-switch to custom-radio -->
                <div class="custom-control custom-radio mb-3">
                    <input type="radio" class="custom-control-input" value="card"
                           id="credit-card-usage" v-model="method" name="erp-method">
                    <label class="custom-control-label" for="credit-card-usage">
                        Create Credit Card Usage ERP
                    </label>
                    <small class="form-text text-muted">
                        Use this option to map credit card usage to specific budget lines.
                    </small>
                </div>
            </div>

            <!-- Fixed button text logic -->
            <button class="btn btn-dark" @click="proceed()" :disabled="!method">
                Proceed to {{ method === 'card' ? 'Credit Card' : 'Budgeting Template' }} &raquo;
            </button>&nbsp;
            <router-link to="/requests" class="btn btn-dark">Cancel</router-link>

        </div>
    </div>
</template>

<script>
import Alerts from "@/components/Alerts.vue";
import CloseRequests from "@/components/CloseRequests.vue";

export default {
    name: "PreCreateRequest",
    components: {Alerts, CloseRequests},
    data() {
        return {
            method: 'template',
            success: null,  // Added missing data properties
            error: null
        }
    },
    methods: {
        proceed() {
            if (this.method === 'template') {
                this.$router.push('/requests/budgeting')
            } else if (this.method === 'card') {
                this.$router.push('/requests/card')
            }
            // Removed unreachable else block since method can only be 'template' or 'card'
        }
    }
}
</script>

<style scoped>

</style>